<span class="fa"
      (click)="clicked()"
      [class.fa-sort]="sortOptionService.currentProperty !== sortProperty"
      [class.fa-sort-asc]="sortOptionService.currentProperty === sortProperty && sortOptionService.ascending"
      [class.fa-sort-desc]="sortOptionService.currentProperty === sortProperty && !sortOptionService.ascending"></span>
